"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeserializers = exports.getInlineButtons = exports.getGlobalButtons = exports.getHoverButtons = exports.getSelectorButtons = exports.getPlugins = void 0;

var react_1 = __importStar(require("react"));

var core_1 = require("@bodiless/core");

var slate_react_1 = require("slate-react");

var lodash_1 = require("lodash");

var plugin_factory_1 = require("./plugin-factory");

var Type_1 = require("./Type");

var RichTextContext_1 = require("./RichTextContext");

var SlateComponentProvider = function SlateComponentProvider(update, type) {
  return function (Component) {
    return function (props) {
      var element = props.element;
      var bodilessNode = core_1.useNode().node;
      var editor = slate_react_1.useSlate();
      var selection = editor.selection; // when the editor looses focus and selection becomes null
      // see https://github.com/ianstormtaylor/slate/issues/3412

      var lastSelection = react_1.useRef(null);
      if (selection !== null) lastSelection.current = selection;
      var getters = {
        getNode: function getNode(path) {
          return element.data[path.join('$')];
        },
        getKeys: function getKeys() {
          return ['slatenode'];
        },
        hasError: function hasError() {
          return bodilessNode.hasError();
        },
        getPagePath: function getPagePath() {
          return bodilessNode.pagePath;
        },
        getBaseResourcePath: function getBaseResourcePath() {
          return bodilessNode.baseResourcePath;
        }
      };
      var actions = {
        setNode: function setNode(path, componentData) {
          var _a;

          var newData = __assign(__assign({}, element.data), (_a = {}, _a[path.join('$')] = __assign({}, componentData), _a));

          return update({
            editor: editor,
            type: type,
            data: newData,
            at: lastSelection.current
          });
        },
        deleteNode: function deleteNode() {}
      };
      var contentNode = new core_1.DefaultContentNode(actions, getters, 'slatenode');
      return react_1.default.createElement(core_1.NodeProvider, {
        node: contentNode
      }, react_1.default.createElement(Component, __assign({}, props)));
    };
  };
};

var getRenderPlugin = function getRenderPlugin(Component) {
  var _a;

  var type = Component.type,
      id = Component.id,
      isVoid = Component.isVoid;
  var _b = (_a = {}, _a[Type_1.RichTextItemType.block] = {
    creates: plugin_factory_1.createElementRenderPlugin,
    WrappedComponent: Component
  }, _a[Type_1.RichTextItemType.inline] = {
    creates: plugin_factory_1.createElementRenderPlugin,
    WrappedComponent: SlateComponentProvider(plugin_factory_1.updateInline, id)(Component)
  }, _a[Type_1.RichTextItemType.mark] = {
    creates: plugin_factory_1.createLeafRenderPlugin,
    WrappedComponent: Component
  }, _a)[type],
      creates = _b.creates,
      WrappedComponent = _b.WrappedComponent; // Clean up th component to add Attributes and remove unused props.

  var CleanComponent = lodash_1.flow(core_1.withoutProps(['isFocused', 'isSelected']), // Remove Children if Void Component.
  core_1.withoutProps(isVoid ? ['children'] : []))(WrappedComponent);
  return creates({
    Component: CleanComponent,
    type: id
  });
};
/*
  getPlugins takes an array of data items and pass them though to getPlugin
*/


var getPlugins = function getPlugins(components) {
  return __spread(Object.values(components).map(function (Component) {
    return getRenderPlugin(Component);
  }));
};

exports.getPlugins = getPlugins;

var getHoverButton = function getHoverButton(Component) {
  var _a;

  var creates = (_a = {}, _a[Type_1.RichTextItemType.block] = plugin_factory_1.createBlockButton, _a[Type_1.RichTextItemType.inline] = plugin_factory_1.createInlineButton, _a[Type_1.RichTextItemType.mark] = plugin_factory_1.createMarkButton, _a);
  return creates[Component.type](Component.id, Component.hoverButton.icon);
};
/*
  getHoverButtons takes a array of Rich Text Items and maps that to a set of Hover Buttons
*/


var getHoverButtons = function getHoverButtons(Components) {
  return Object.values(Components) // eslint-disable-next-line no-prototype-builtins
  .filter(function (Component) {
    return Component.hoverButton;
  }).map(function (Component) {
    return getHoverButton(Component);
  });
};

exports.getHoverButtons = getHoverButtons;

var getGlobalButton = function getGlobalButton(Component) {
  return function (editor) {
    return {
      icon: Component.globalButton.icon,
      name: Component.id,
      global: true,
      isActive: function isActive() {
        return plugin_factory_1.hasBlock(Component.id, editor);
      },
      handler: function handler() {
        var options = {
          editor: editor,
          blockType: Component.id,
          value: editor.value
        };

        if (Component.isAtomicBlock) {
          plugin_factory_1.insertBlock(options);
        } else {
          plugin_factory_1.toggleBlock(options);
        }
      }
    };
  };
};
/*
  getSelectorButton takes a Rich Text Item and returns a button used in the RichText Selector
*/


var getSelectorButton = function getSelectorButton(Component) {
  return function (props) {
    var _a;

    var _b = (_a = {}, _a[Type_1.RichTextItemType.block] = {
      toggleFuc: function toggleFuc(_a) {
        var editor = _a.editor,
            name = _a.name;
        return plugin_factory_1.toggleBlock({
          editor: editor,
          blockType: name
        });
      },
      has: plugin_factory_1.hasBlock
    }, _a[Type_1.RichTextItemType.inline] = {
      toggleFuc: function toggleFuc(_a) {
        var editor = _a.editor,
            name = _a.name;
        return plugin_factory_1.toggleInline({
          editor: editor,
          inlineType: name
        });
      },
      has: plugin_factory_1.hasInline
    }, _a[Type_1.RichTextItemType.mark] = {
      toggleFuc: function toggleFuc(_a) {
        var editor = _a.editor,
            name = _a.name;
        return plugin_factory_1.toggleMark({
          editor: editor,
          markType: name
        });
      },
      has: plugin_factory_1.hasMark
    }, _a)[Component.type],
        toggleFuc = _b.toggleFuc,
        has = _b.has;
    var ClickableWrapper = RichTextContext_1.useUI().ClickableWrapper;
    var Button = plugin_factory_1.withToggle({
      toggle: function toggle(_a) {
        var editor = _a.editor;
        toggleFuc({
          editor: editor,
          name: Component.id
        });
      },
      isActive: function isActive(editor) {
        return has(Component.id, editor);
      },
      icon: 'none'
    })(ClickableWrapper);
    return react_1.default.createElement(Button, null, react_1.default.createElement(Component, __assign({}, props), Component.id));
  };
};

var getInlineButtons = function getInlineButtons(components) {
  return Object.values(components).filter(function (Component) {
    return Component.type === Type_1.RichTextItemType.inline;
  });
};

exports.getInlineButtons = getInlineButtons;
/*
  getSelectorButtons takes an array of RichTextitems and maps that to a array of buttons
  used in the Rich Text selector
*/

var getSelectorButtons = function getSelectorButtons(components) {
  return Object.values(components).filter(function (Component) {
    return Component.type !== Type_1.RichTextItemType.block;
  }) // eslint-disable-next-line no-prototype-builtins
  .filter(function (Component) {
    return !Component.hasOwnProperty('hoverButton');
  }).map(function (Component) {
    return getSelectorButton(Component);
  });
};

exports.getSelectorButtons = getSelectorButtons;
/*
  getGlobalButtons takes an array of RichTextitems and maps that to a array of objects used
  to create global buttons
*/

var getGlobalButtons = function getGlobalButtons(components) {
  var componentsWithButtons = Object.values(components) // eslint-disable-next-line no-prototype-builtins
  .filter(function (Component) {
    return Component.hasOwnProperty('globalButton');
  });
  if (!componentsWithButtons.length) return undefined;
  return function (editor) {
    return componentsWithButtons.map(function (Component) {
      return getGlobalButton(Component)(editor);
    });
  };
};

exports.getGlobalButtons = getGlobalButtons;

var getDeserializers = function getDeserializers(components) {
  return Object.keys(components).reduce(function (prev, key) {
    var _a;

    var Component = components[key];
    return __assign(__assign({}, prev), Component.hasOwnProperty('htmlDeserializer') ? (_a = {}, _a[key] = Component.htmlDeserializer, _a) : {});
  }, {});
};

exports.getDeserializers = getDeserializers;